<script setup lang="ts">
import { MaybeRef } from 'vue'
import { defaultUrls } from '../../../stores/config'
import { EndpointResponse } from '../../../types/base'
import PejerDonutChart from '../PejerDonutChart.vue'
defineProps<{
  data: MaybeRef<EndpointResponse<(typeof defaultUrls)['payments']['stats']>>
  horizontal?: boolean
}>()
</script>
<template>
  <PejerDonutChart
    :data="data"
    :horizontal="horizontal"
    title="Payment Status"
    :data-options="[
      { key: 'initiatedPaymentCount', name: 'Initiated', color: '#aaaaaa' },
      { key: 'reservedPaymentCount', name: 'Reserved', color: '#6366F1' },
      { key: 'refundedPaymentCount', name: 'Refunded', color: '#FF9999' },
      { key: 'chargedPaymentCount', name: 'Charged', color: '#13b982' },
      { key: 'failedPaymentCount', name: 'Failed', color: '#FF0000' },
      { key: 'cancelledPaymentCount', name: 'Cancelled', color: '#FFA500' },
    ]"
  />
</template>
